import { OK } from 'http-status-codes'

import getAxiosInstance from '../../helpers/get_axios_instance'

export class ReporteEstadoPorSiloService {
  static async getReporte (sector) {
    const axios = getAxiosInstance()
    const promise = axios.get(`/consulta_detalle_espacio_silo_sector?r={"clave":{"sector":"S${sector}"}}`)
    return promise.then(result => {
      const { status, data } = result
      if (status !== OK) throw new Error('No se pudo obtener el reporte por silo.')
      return data
    })
  }

  static async getReporteDeSector (sector) {
    const axios = getAxiosInstance()
    const promise = axios.get(`/consulta_total_espacio_por_sector?r={"clave":{"sector":"S${sector}"}}`)
    return promise.then(result => {
      const { status, data } = result
      if (status !== OK) throw new Error('No se pudo obtener el reporte por sector.')
      return data
    })
  }
}
